export default __webpack_public_path__ + "static/media/NotoSans-Bold.d0313171.ttf";